import React, { useEffect, useState } from 'react';

import Paginator from '../../elements/paginator';
import axios from '../../services/MyAxios';

import Card from 'crm/elements/common/Card';

function PromoCodeValues({ url, promoCode }) {
    const [codes, setCodes] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);

    const getCodes = (page = 1) => {
        const requestUrl = `${url}/codes?page=${page}`;
        axios.get(requestUrl).then((response) => {
            setCodes(response.data.data);
            setCurrentPage(response.data.current_page);
            setLastPage(response.data.last_page);
        });
    };

    useEffect(() => {
        getCodes();
    }, []);

    function getUsageOfCodes() {
        let text = promoCode.total_uses;
        if (promoCode.max_uses > 0) {
            text += ` / ${promoCode.number_of_codes * promoCode.max_uses}`;
        }

        return (
            <span className="badge badge-primary" title="Number of used codes">
                {text}
            </span>
        );
    }

    return (
        <Card title={<>Codes {getUsageOfCodes()}</>}>
            <div className="row">
                {codes.map((code) => (
                    <div className="col col-sm-6 col-md-4 col-lg-3" key={code.id}>
                        <p className={promoCode.max_uses > 0 && code.uses >= promoCode.max_uses ? 'text-muted' : ''}>
                            {code.value} ({code.uses})
                        </p>
                    </div>
                ))}
            </div>
            <Paginator currentPage={currentPage} lastPage={lastPage} onPageChange={getCodes} />
        </Card>
    );
}

export default PromoCodeValues;
